// extracted by mini-css-extract-plugin
module.exports = {"container":"wallet-info_container__Y8TlC","address":"wallet-info_address__k_TcF"};